var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconawesomePause(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-pause",
    "data-name": "Icon awesome-pause",
    d: "M4.821,17.18H1.607A1.608,1.608,0,0,1,0,15.573V3.787A1.608,1.608,0,0,1,1.607,2.18H4.821A1.608,1.608,0,0,1,6.429,3.787V15.573A1.608,1.608,0,0,1,4.821,17.18ZM15,15.573V3.787A1.608,1.608,0,0,0,13.393,2.18H10.179A1.608,1.608,0,0,0,8.571,3.787V15.573a1.608,1.608,0,0,0,1.607,1.607h3.214A1.608,1.608,0,0,0,15,15.573Z",
    transform: "translate(0 -2.18)",
    fill: "#991f1f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconawesomePause);
export default __webpack_public_path__ + "static/media/Icon awesome-pause.12a02486ccb164e02c1511b8f89239ab.svg";
export { ForwardRef as ReactComponent };